import { GridUtils } from '@atlassian/amkt-common';
import { ConstrainedContainer } from '@atlassian/mpac-ui';
import styled from '@emotion/styled';

import { PAGE_CONTAINER_MAX_WIDTH } from '../../../../../../../constants';

export const Container = styled(ConstrainedContainer)`
  padding: 30px 0;

  @media screen and (max-width: ${PAGE_CONTAINER_MAX_WIDTH}) {
    padding: ${GridUtils.GutterSpacing.Base};
  }

  min-height: 100vh;
  position: relative;
`;

export const WarningContainerAfterHeader = styled.div`
  margin-bottom: 2rem;
`;
